type ElfsightWidgetType = "google" | "yelp";

const widgets: Record<ElfsightWidgetType, string> = {
  google: "elfsight-app-f5d74cdb-2e4c-4afb-b3f2-b41a44e3b838",
  yelp: "elfsight-app-a6af291b-5e4d-4375-8a1f-6fb883a612d4",
};

interface ElfsightWidgetProps {
  type?: ElfsightWidgetType;
}

export default function ElfsightWidget({ type = "yelp" }: ElfsightWidgetProps) {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className={widgets[type]} />
    </div>
  );
}